import React, { Fragment } from 'react'

const NotExist = () => {
    return (
        <Fragment>
            <h1>Page do not Exist</h1>
            <p className='lead'>The page you are looking for does not exist</p>
        </Fragment>
    )
}

export default NotExist
